/** Session flag : handoff admin Rantanplan → rintintin-booking en cours. */
export const BOOKING_ADMIN_HANDOFF_KEY = 'booking_admin_handoff';

export function isBookingAdminHandoffActive(): boolean {
  if (typeof window === 'undefined') return false;
  const path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
  if (path !== '/admin-handoff') return false;
  if (window.location.hash.startsWith('#t=')) return true;
  return sessionStorage.getItem(BOOKING_ADMIN_HANDOFF_KEY) === '1';
}

export function markBookingAdminHandoffActive(): void {
  sessionStorage.setItem(BOOKING_ADMIN_HANDOFF_KEY, '1');
}

export function clearBookingAdminHandoffActive(): void {
  sessionStorage.removeItem(BOOKING_ADMIN_HANDOFF_KEY);
}
